import CryptoJS from 'crypto-js';

export const CommonService = {
  changeAlias: function (alias) {
    if (!alias) {
      return alias;
    }
    let str = alias;
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    str = str.replace(/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|“|”|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, ' ');
    str = str.replace(/ + /g, ' ');
    str = str.trim();
    str = str.replace(/\s/g, '-');
    return str;
  },

  changeAlias2: function (alias) {
    if (!alias) {
      return alias;
    }
    let str = alias;
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a'); 
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e'); 
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i'); 
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o'); 
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u'); 
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y'); 
    str = str.replace(/đ/g, 'd');
    str = str.replace(/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|“|”|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, ' ');
    str = str.trim();
    return str;
  },

  getPackageTitle: function (name) {
    switch (name) {
      case 'tich-hop':
        return 'Tích hợp';
      case 'data':
        return 'Data';
      case 'roaming':
        return 'Roaming';
      case 'thong-tin':
        return 'Thông tin';
      case 'home-combo':
        return 'Home Combo';
      case 'home-mobi':
        return 'Home Mobi';
      case 'home-tv':
        return 'Home TV';
      case 'home-internet':
        return 'Home Internet';
      case 'mytv':
        return 'MyTV';
      case 'mytv-net':
        return 'MyTV Net';
      case 'co-dinh':
        return 'Cố định';
      default:
        return 'Data';
    }
  },

  REGEX_PHONE_NUMBER: /^\+?(?:[0-9]??).{9,12}[0-9]/,

  encryptAES: function (data) {
    const key = CryptoJS.enc.Latin1.parse("dqeqgig123ndb123dsfsdf23g4d56jfq");
    const iv = CryptoJS.enc.Latin1.parse("");
    const plaintextData = CryptoJS.AES.encrypt(data, key, { iv: iv });
    return plaintextData.toString();
  },

  decryptAES: function (data) {
    const rawData = CryptoJS.enc.Base64.parse(data);
    const key = CryptoJS.enc.Latin1.parse("dqeqgig123ndb123dsfsdf23g4d56jfq");
    const iv = CryptoJS.enc.Latin1.parse("");
    const plaintextData = CryptoJS.AES.decrypt({ ciphertext: rawData }, key, { iv: iv });
    return plaintextData.toString(CryptoJS.enc.Latin1);
  },
  
  encryptAESCustomKey: function (data, secretKey) {
    const key = CryptoJS.enc.Latin1.parse(secretKey);
    const iv = CryptoJS.enc.Latin1.parse("");
    const plaintextData = CryptoJS.AES.encrypt(data, key, { iv: iv });
    return plaintextData.toString();
  },
  
  dencryptAESCustomKey: function (data, secretKey) {
    const rawData = CryptoJS.enc.Base64.parse(data);
    const key = CryptoJS.enc.Latin1.parse(secretKey);
    const iv = CryptoJS.enc.Latin1.parse("");
    const plaintextData = CryptoJS.AES.decrypt({ ciphertext: rawData }, key, { iv: iv });
    return plaintextData.toString(CryptoJS.enc.Latin1);
  },

  findGetParameter: function (paramSearch) {
    let result = {}
    const search = paramSearch || window.location.search;
    if (search) {
      search.substr(1).split("&").forEach(item => {
        result[item.split("=")[0]] = item.split("=")[1]
      })
    }
    return result;
  },

  dataURLtoFile: function (dataurl, filename) {
    let arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  },

  convert0to84: function (msisdn) {
    if (msisdn) {
      const convertedMsisdn = msisdn.startsWith('0') ? `84${msisdn.slice(1)}` : msisdn;
      return convertedMsisdn;
    } else {
      return msisdn
    }
  },

  convert84to0: function (msisdn) {
    if (msisdn) {
      const convertedMsisdn = msisdn.startsWith('84') ? `0${msisdn.slice(2)}` : msisdn;
      return convertedMsisdn;
    } else {
      return msisdn
    }
  },
}
